// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopPaymentListResultModel from '../../model/shop-payment-list-result-model';
import ShopPaymentListResultDTO from '../dto/shop-payment-list-result-dto';
import dtoSchema from '../schemas/shop-payment-list-result-schema';
import ShopPaymentModel from '../../model/shop-payment-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopPaymentListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopPaymentListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopPaymentModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopPaymentModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopPaymentListResultDTO>): ShopPaymentListResultModel;
  static toModel(dto: DeepPartial<ShopPaymentListResultDTO> | undefined | null): ShopPaymentListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopPaymentListResultDTO> | undefined | null): ShopPaymentListResultModel | undefined {
    return dto ? new ShopPaymentListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopPaymentListResultModel> | ShopPaymentListResultModel): ShopPaymentListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopPaymentListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopPaymentListResultModel, can not map to ShopPaymentListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
